import { PROJECT_PRODUCT_TYPE_TRANSLATIONS } from "core/constants/project/productType";
import { makeUrl } from "utils/common";

export const getTableColumns = additionalProps => {
    const { t } = additionalProps;

    return [
        {
            title: "backoffice.projects.name",
            dataIndex: "name",
            mobileLevel: 1
        },
        {
            title: "backoffice.projects.subDomain",
            dataIndex: "subDomain",
            mobileLevel: 2,
            render: value => value ?? "-"
        },
        {
            title: "backoffice.projects.relativePath",
            dataIndex: "relative",
            mobileLevel: 2,
            render: value => value ? `/${value}` : "-"
        },
        {
            title: "backoffice.projects.language",
            dataIndex: "languageCode",
            mobileLevel: 3,
            render: value => value ? t(`backoffice.languages.${value.toLowerCase()}`) : ""
        },
        {
            title: "backoffice.projects.product",
            dataIndex: "product",
            render: value => t(PROJECT_PRODUCT_TYPE_TRANSLATIONS[value]),
            mobileLevel: 4
        },
        {
            title: "backoffice.projects.createdAt",
            dataIndex: "createdAt",
            isDateTime: true,
            mobileLevel: 5
        },
        {
            title: "backoffice.projects.createdBy",
            dataIndex: "createdBy",
            mobileLevel: 6
        },
    ]
}
